export var HolidayYearActionKind;
(function (HolidayYearActionKind) {
    HolidayYearActionKind["ModifyEndDate"] = "ModifyEndDate";
    HolidayYearActionKind["ModifyWorkingDays"] = "ModifyWorkingDays";
})(HolidayYearActionKind || (HolidayYearActionKind = {}));
